import React from 'react';
import { NavLink } from 'react-router-dom';

const Navbar = () => {
  const modules = JSON.parse(localStorage.getItem('modules'));
  const isProjectModuleEnabled = modules.some(module => module.P === 1);
  const isServiceDashboardModuleEnabled = modules.some(module => module.S === 1);

  const navbarStyle = {
    display: 'flex',
    backgroundColor: '#fff',
    overflow: 'auto',
    borderRadius: '50px',
    alignItems: 'center',
    justifyContent: 'left',  // Center items horizontally
    fontFamily: 'Arial, Helvetica, sans-serif',
  };

  const linkStyle = {
    display: 'inline-block',
    padding: '5px',
    color: 'black',
    textDecoration: 'none',
    fontSize: '17px',
    borderRadius: '50px',
    margin: '0 10px', // Add margin between links for spacing
  };

  const activeStyle = {
    backgroundColor: '#5B38FF',
    color: 'white',
    fontWeight: 'bold',
  };

  return (
    <div>
      <br /><br /><br />
      <div className="navbar" style={navbarStyle}>
        <h5 style={{ margin: '0' }}>Dashboard</h5>
        {isProjectModuleEnabled && (
          <NavLink exact to="/timeinlive/dashboard" style={linkStyle} activeStyle={activeStyle}>
            <i className="fa fa-calendar-check-o" aria-hidden="true"></i> Project
          </NavLink>
        )}
        {isServiceDashboardModuleEnabled && (
          <NavLink exact to="/timeinlive/serviceDashboard" style={linkStyle} activeStyle={activeStyle}>
            <i className="fa fa-fw  fa-wrench"></i> Service
          </NavLink>
        )}
      </div>
    </div>
  );
};

export default Navbar;
